import {ReactNode} from 'react'
import {motion} from 'framer-motion'

export const MobileParallaxImageWrapper = ({children, className}: {children: ReactNode; className?: string}) => {
  return (
    <motion.div
      className={className}
      initial={{opacity: 0, translateY: 20}}
      whileInView={{opacity: 1, translateY: 0}}
      viewport={{amount: 0.55, once: false}}
      transition={{duration: 0.7, ease: 'easeInOut', delay: 0.7}}
    >
      {children}
    </motion.div>
  )
}
